import EngineModule from '../EngineModule';

export default () => EngineModule.all.find(x => x.id === 'product-replayLinkModal') || new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'product-replayLinkModal',
	dependencies :     [
		'oms-basket'
	],
	allowedCustomers : null,
	generateComponentConfiguration() {
		return {};
	},
	insertionPath : null
});
